import { render, staticRenderFns } from "./CheckOrderInfos.vue?vue&type=template&id=4911e71a&"
import script from "./CheckOrderInfos.vue?vue&type=script&lang=js&"
export * from "./CheckOrderInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports